import { useMutation } from '@apollo/client/react';

import useAgent from 'hooks/useAgent';
import useRouteParams from 'hooks/useRouteParams';
import { ADD_APPLICATION_NOTE, ADD_CUSTOMER_NOTE } from 'mutations/notes';

const refetchQueries = ['NotesInteractionsZendeskRecords', 'GetAgentNotes'];

const useAddNote = () => {
  const agent = useAgent();
  const { customerId, applicationId } = useRouteParams();

  const [addApplicationNote, applicationNoteMutation] = useMutation(
    ADD_APPLICATION_NOTE,
    {
      refetchQueries,
    },
  );

  const [addCustomerNote, customerNoteMutation] = useMutation(
    ADD_CUSTOMER_NOTE,
    {
      refetchQueries,
    },
  );

  const addNote = async ({ message, isSticky = false, category = null }) => {
    const variables = {
      message,
      product: 'CREDIT',
      agentId: agent?.user?.requester_id,
      agentName: agent?.user?.name,
      isSticky,
      ...(category && { category }),
    };

    let submitNote;
    if (customerId) {
      submitNote = addCustomerNote;
      variables.customerId = customerId;
    } else if (applicationId) {
      submitNote = addApplicationNote;
      variables.applicationId = applicationId;
    }

    return await submitNote({
      variables,
    });
  };

  const addNoteMutation = applicationId
    ? applicationNoteMutation
    : customerNoteMutation;

  return [addNote, addNoteMutation];
};

export default useAddNote;
